import ImageRound from '@/components/elements/ImageRound';
import TextoDescripcion from '@/components/elements/TextoDescripcion';
import TituloDescripcion from '@/components/elements/TituloDescripcion';
import TituloSeccionH2 from '@/components/elements/TituloSeccionH2';
import { black, primary, white } from '@/constants/Colors';
import { LoginDatos } from '@/objects/User';
import { comprobarAvatar } from '@/util/Articulos';
import { esPremium, idUsuarioMod } from '@/util/StringsUtil';
import { Card } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import BadgesUser from './BadgesUser';
import TextFieldCustom, { AutocompleteValues, InputTypes } from '@/components/elements/TextFieldCustom';
import { dateToTextTForm } from '@/util/MagicDate';
import Boton from '@/components/elements/Boton';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import { useServices } from '@/context/ServicesProvider';
import { mostrarAlerta } from '@/context/UtilsContext';
import { refrescarDatosUsuarioLogin } from '@/util/LocalStorageLoaded';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { subtitulo } from '@/constants/Dimens';
//Definimos los tipos de datos que va a recibir el componente en forma de interfaz
interface Props {
    datosUsuario: LoginDatos | null;
    setDatosUsuario: React.Dispatch<React.SetStateAction<LoginDatos | null | undefined>>;
}

const DatosUsuario: React.FC<Props> = ({ datosUsuario, setDatosUsuario }) => {

    const { usersQueries } = useServices();

    const [nombre, setNombre] = React.useState<string>("");

    const [fechaPremium, setFechaPremium] = React.useState<string>("");
    const [premiumUser, setPremiumUser] = React.useState<boolean>(false);


    const { t } = useTranslation();

    useEffect(() => {
        setNombre(datosUsuario?.name!);
        if (esPremium(String(datosUsuario?.premium))) {
            setFechaPremium(dateToTextTForm(datosUsuario?.premium!, t));
        }
        setPremiumUser(esPremium(String(datosUsuario?.premium)));
    }, [datosUsuario]);


    function guardarDatos() {
        usersQueries?.guardarDatosPerfil(datosUsuario?.id_user!, nombre).then((response) => {
            if (response.status === 200) {
                if (datosUsuario) {
                    datosUsuario.name = nombre;
                    setDatosUsuario(datosUsuario);
                }
                mostrarAlerta({
                    title: t('common:opciones.informacion'),
                    content: t("menu:secciones.ajustes_perfil.datos_actualizados_correctamente"),
                    showCancelButton: false,
                });
                usersQueries?.obtenerDatosUsuario().then((response) => {
                    if (response.data) {
                        refrescarDatosUsuarioLogin(response.data);
                    }
                }
                );
            }
        });
    }


    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: "100%" }}>
            <TituloSeccionH2 fontSize={subtitulo} texto={t("menu:secciones.ajustes_perfil.datos_usuario")} />
            <div style={{ display: 'flex', flexDirection: 'column', width: "100%", alignItems: 'center', }}>
                <Card style={{
                    display: 'flex', flexDirection: 'column', justifyContent: 'center',
                    alignItems: 'center', gap: '5px', padding: "20px", width: "100%"
                }}>
                    <div>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                            <ImageRound src={comprobarAvatar(datosUsuario?.image!)} title={t("header:title_logo_user")} alt={"header:alt_logo_user"}
                                width={100} height={100} />
                        </div>
                        <div >
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: "center", marginBottom: "20px" }}>
                                <TituloDescripcion color={black} >{t('menu:secciones.ajustes_perfil.id_usuario')}</TituloDescripcion>
                                <TextoDescripcion>{idUsuarioMod(Number(datosUsuario?.id_user))}</TextoDescripcion>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: "center", marginBottom: "20px" }}>
                                <BadgesUser datosUsuario={datosUsuario} setDatosUsuario={setDatosUsuario} />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start", marginBottom: "20px" }}>
                                <TituloDescripcion color={black} >{t('menu:secciones.ajustes_perfil.email')}</TituloDescripcion>
                                <TextoDescripcion>{datosUsuario?.email}</TextoDescripcion>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start", marginBottom: "20px" }}>
                                <TituloDescripcion color={black} >{t('menu:secciones.ajustes_perfil.creditos')}</TituloDescripcion>
                                <TextoDescripcion>{datosUsuario?.points}</TextoDescripcion>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start", marginBottom: "20px" }}>
                                <TituloDescripcion color={black} >{t('menu:secciones.ajustes_perfil.nombre')}</TituloDescripcion>
                                <TextFieldCustom autocomplete={AutocompleteValues.Name} inputType={InputTypes.Text} label={t("menu:secciones.ajustes_perfil.cambiar_nombre")} value={nombre} setValue={setNombre} />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start", marginBottom: "20px" }}>
                                <TituloDescripcion color={black} >{t('menu:secciones.ajustes_perfil.telefono_titulo')}</TituloDescripcion>
                                <TextoDescripcion>{t("menu:secciones.ajustes_perfil.numero_telefono_quitado")}</TextoDescripcion>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start", marginBottom: "20px" }}>
                                <TituloDescripcion color={black} >{t('menu:secciones.ajustes_perfil.fecha_premium')}</TituloDescripcion>
                                {premiumUser ? <TextoDescripcion>{fechaPremium}</TextoDescripcion> :
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start" }}>
                                        <TextoDescripcion>{t("menu:secciones.ajustes_perfil.no_eres_usuario_premium")}</TextoDescripcion>
                                        <Boton color={white} colorTexto={primary} width="300px" startIcon={<WorkspacePremiumIcon />} texto={t("menu:secciones.ajustes_perfil.hacerse_premium")} onClick={() =>
                                            //Abre dashboard/premium
                                            window.open("/dashboard/premium", "_self")
                                        } />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <Boton fullWidth startIcon={<BrowserUpdatedIcon />} texto={t("menu:secciones.ajustes_perfil.actualizar_datos")} onClick={() => guardarDatos()} />
                </Card>
            </div>
        </section>
    );
}

export default DatosUsuario;
